import type { BoardDoc } from '../../doc/BoardDoc';
import type { Rect } from '../../doc/geometry';
import { exportSettings } from './exportSettings';
import { downloadCanvas, itemsIn, rasterize } from './rasterize';

function boardBackground(board: BoardDoc): string | null {
  if (!exportSettings.getState().background) return null;
  const bg = board.meta.get('bg');
  if (typeof bg === 'string' && bg) return bg;
  const pane = document.querySelector('.pane');
  return pane ? getComputedStyle(pane).getPropertyValue('--canvas-bg').trim() || '#ffffff' : '#ffffff';
}

/** Renders and downloads the given world rect with the current export settings. */
export async function exportRect(board: BoardDoc, title: string, rect: Rect, label: string): Promise<void> {
  const s = exportSettings.getState();
  const items = itemsIn(board, rect);
  const canvas = await rasterize(board, items, rect, { scale: s.scale, background: boardBackground(board), padding: s.padding });
  const name = `${(title || board.boardId).replace(/[^\w.-]+/g, '_')}-${label}@${s.scale}x.png`;
  await downloadCanvas(canvas, name);
}
